import { isServer } from "@decibeltrade/web-core/utils";
import { useEffect, useLayoutEffect } from "react";

export const useIsomorphicLayoutEffect = isServer() ? useEffect : useLayoutEffect;
